import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function AdminBadWords() {
  const [cfg, setCfg] = useState(null);
  const [word, setWord] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/badwords").then((r) => setCfg(r.data)).catch(() => setCfg(false)); }, []);
  if (cfg === false) return <div className="p-6 text-center text-sm text-slate-500">Nuk u ngarkua. Rifresko faqen.</div>;
  if (!cfg) return <div className="p-6 text-center text-sm text-slate-500">Duke ngarkuar...</div>;

  const add = (e) => {
    e.preventDefault();
    const list = [...new Set(word.split(",").map((w) => w.trim().toLowerCase()))].filter((w) => w && !cfg.words.includes(w));
    if (list.length) setCfg({ ...cfg, words: [...cfg.words, ...list] });
    setWord("");
  };
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/admin/badwords", cfg); setCfg(r.data); toast.success("U ruajt"); }
    catch (e) { toast.error(errMsg(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="space-y-3 bg-white rounded-2xl p-4 border border-slate-100" data-testid="admin-badwords">
      <p className="text-xs text-slate-500">Këto fjalë mbulohen me **** kudo ku shkruajnë përdoruesit: mesazhe, komunitet, komente, vlerësime dhe shpallje.</p>
      <form onSubmit={add} className="flex gap-2">
        <input data-testid="badword-input" value={word} onChange={(e) => setWord(e.target.value)} placeholder="Shkruaj fjalën (ose disa me presje)" className="flex-1 min-w-0 h-11 rounded-xl border border-slate-200 px-3 text-sm" />
        <Button data-testid="badword-add" type="submit" className="rounded-xl h-11 bg-slate-900">Shto</Button>
      </form>
      <div className="flex flex-wrap gap-1.5" data-testid="badword-list">
        {cfg.words.map((w) => (
          <span key={w} className="flex items-center gap-1 bg-rose-50 text-rose-700 text-xs font-semibold rounded-full pl-2.5 pr-1 py-1 break-all">
            {w}
            <button data-testid={`badword-remove-${w}`} onClick={() => setCfg({ ...cfg, words: cfg.words.filter((x) => x !== w) })} className="w-5 h-5 rounded-full hover:bg-rose-100 flex items-center justify-center"><X className="w-3 h-3" /></button>
          </span>
        ))}
        {!cfg.words.length && <span className="text-xs text-slate-400">Asnjë fjalë ende.</span>}
      </div>
      <div>
        <div className="text-xs font-semibold text-slate-600 mb-1">Mesazhi që merr përdoruesi</div>
        <textarea data-testid="badword-message" value={cfg.message} onChange={(e) => setCfg({ ...cfg, message: e.target.value })} rows={3} className="w-full rounded-xl border border-slate-200 p-3 text-sm" />
        <p className="text-[11px] text-slate-400">{"{fjalet}"} zëvendësohet me fjalët që shkroi.</p>
      </div>
      <Button data-testid="badword-save" onClick={save} disabled={saving} className="w-full rounded-xl h-11 bg-emerald-500 hover:bg-emerald-600 font-bold">{saving ? "Duke ruajtur..." : "Ruaj"}</Button>
    </div>
  );
}
